import React from 'react';
import styles from './rightArrow.module.sass';
import applyWrappers from 'wrappers/ComponentWrapper';
import { useSelector } from 'react-redux';

const RightArrow = (props) => {
	
	const fillColor = '#4DF4FE';
	const strokeColor = '#000000';
	
	return (
		<div styleName="main-component">
			<svg width="100%" height="100%" viewBox="0 0 66 66" fill="none">
				<circle cx="34" cy="34" r="32" fill={fillColor} />
				<circle cx="32" cy="32" r="31.5" stroke={strokeColor} />
				<path d="M28 21L39 32.5L28 44" stroke={strokeColor} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
			</svg>
		</div>
	);
}

export default applyWrappers(RightArrow, styles);